const PSGC_BASE_URL = 'https://psgc.cloud/api';

const cache = new Map();

const jsonFetch = async (url) => {
  const cached = cache.get(url);
  if (cached) return cached;

  const resp = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!resp.ok) {
    const body = await resp.text().catch(() => '');
    const err = new Error(`PSGC request failed (${resp.status})`);
    err.status = resp.status;
    err.body = body;
    throw err;
  }

  const data = await resp.json();
  cache.set(url, data);
  return data;
};

export const fetchRegions = async () => {
  const url = `${PSGC_BASE_URL}/regions`;
  const regions = await jsonFetch(url);
  return (regions || []).map((r) => ({ code: r.code, name: r.name }));
};

export const fetchProvincesByRegion = async (regionCode) => {
  if (!regionCode) return [];
  const url = `${PSGC_BASE_URL}/regions/${encodeURIComponent(regionCode)}/provinces`;
  const provinces = await jsonFetch(url);
  return (provinces || []).map((p) => ({ code: p.code, name: p.name }));
};

export const fetchCitiesMunicipalitiesByProvince = async (provinceCode) => {
  if (!provinceCode) return [];
  const url = `${PSGC_BASE_URL}/provinces/${encodeURIComponent(provinceCode)}/cities-municipalities`;
  const citiesMuns = await jsonFetch(url);
  return (citiesMuns || []).map((cm) => ({
    code: cm.code,
    name: cm.name,
    type: cm.type,
  }));
};

export const fetchBarangaysByCityMunicipality = async (cityMunicipalityCode) => {
  if (!cityMunicipalityCode) return [];
  const url = `${PSGC_BASE_URL}/cities-municipalities/${encodeURIComponent(cityMunicipalityCode)}/barangays`;
  const barangays = await jsonFetch(url);
  return (barangays || []).map((b) => ({ code: b.code, name: b.name }));
};

export const fetchAllProvinces = async () => {
  const url = `${PSGC_BASE_URL}/provinces`;
  const provinces = await jsonFetch(url);
  return (provinces || []).map((p) => ({ code: p.code, name: p.name }));
};

export const fetchAllCitiesMunicipalities = async () => {
  const url = `${PSGC_BASE_URL}/cities-municipalities`;
  const citiesMuns = await jsonFetch(url);
  return (citiesMuns || []).map((cm) => ({
    code: cm.code,
    name: cm.name,
    type: cm.type,
    provinceCode: cm.provinceCode,
  }));
};
